export interface ScalesReading {
  value: number
  createdAt: number
}

export interface ScalesReadingState {
  reading: ScalesReading
  isValid: boolean
  previousValueDelta: number
  numReadingsSinceUpdate: number
  msSinceLastUpdate: number
  receivedAt: number
  updatedAt: number
  previousUpdatedValue: number
  isWsOpen: boolean
}

const now = Date.now()

export const initialState: ScalesReadingState = {
  reading: {
    value: 0,
    createdAt: now,
  },
  isValid: false,
  previousValueDelta: 0,
  receivedAt: now,
  updatedAt: now,
  numReadingsSinceUpdate: 0,
  msSinceLastUpdate: 0,
  previousUpdatedValue: 0,
  isWsOpen: false,
}
